import React from "react";

import mileageTrackerIcon from "assets/reports/mileageTrackerUpsell.svg";
import { defineMessages, useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import { MILEAGE_TRACKING_UPSELL_URL } from "@app/scene/map/utils/consts";

import styles from "./Upsell.module.scss";

const messages = defineMessages({
  description: {
    id: "settings.organizationDetails.mileageTracking.description",
    defaultMessage:
      "Learn how much time your team spends behind the wheel with MMC Mileage Tracker. Know if a drive was auto-tracked or manually entered, see business drives happening in real time, and export comprehensive reports in seconds.",
    description: "Description of mileage tracking",
  },
  interested: {
    id: "settings.organizationDetails.mileageTracking.interested",
    defaultMessage: "I’m Interested",
    description: "I'm interested button",
  },
  title: {
    id: "settings.organizationDetails.mileageTracking.title",
    defaultMessage: "Auto-track and classify drives",
    description: "Mileage tracker upsell title",
  },
});

interface Props {}

const Upsell: React.FC<Props> = () => {
  const intl = useIntl();
  return (
    <div className={styles.container}>
      <img alt="mileage tracker icon" className={styles.icon} src={mileageTrackerIcon} />
      <div className={styles.info}>
        <span className={styles.title}>{intl.formatMessage(messages.title)}</span>
        <span className={styles.description}>{intl.formatMessage(messages.description)}</span>
      </div>
      <Button href={MILEAGE_TRACKING_UPSELL_URL} target="_blank" type="primary">
        {intl.formatMessage(messages.interested)}
      </Button>
    </div>
  );
};

export default Upsell;
